import { Dispatch, SetStateAction } from 'react';

import { RegexPatterns } from './constants';

/**
 * Runs the 4 needed password validations, and updates states accordingly by testing Regex patterns.
 * Meant to be a helper function for the PasswordValidation component.
 * @param string password string to be validated
 * @param function setHasSixLetters: function for updating hasSixLetters state.
 *
 * Note: All other params do the same as setHasSixLetters, for their respective validation
 *
 * @returns void, as the function's purpose is to update state (not pure function)
 */
export const validatePasswordAndUpdateStates = (
  password: string,
  setHasSixLetters: Dispatch<SetStateAction<boolean>>,
  setHasUppercase: Dispatch<SetStateAction<boolean>>,
  setHasNumber: Dispatch<SetStateAction<boolean>>,
  setHasSpecialChar: Dispatch<SetStateAction<boolean>>,
): void => {
  if (RegexPatterns.IS_BIGGER_THAN_SIX_CHARS.test(password)) {
    setHasSixLetters(true);
  }
  if (!RegexPatterns.IS_BIGGER_THAN_SIX_CHARS.test(password)) {
    setHasSixLetters(false);
  }

  if (RegexPatterns.HAS_UPPERCASE_LETTER.test(password)) {
    setHasUppercase(true);
  }
  if (!RegexPatterns.HAS_UPPERCASE_LETTER.test(password)) {
    setHasUppercase(false);
  }

  if (RegexPatterns.HAS_NUMBER.test(password)) {
    setHasNumber(true);
  }
  if (!RegexPatterns.HAS_NUMBER.test(password)) {
    setHasNumber(false);
  }

  if (RegexPatterns.HAS_SPECIAL_CHAR.test(password)) {
    setHasSpecialChar(true);
  }
  if (!RegexPatterns.HAS_SPECIAL_CHAR.test(password)) {
    setHasSpecialChar(false);
  }
};
